export default __webpack_public_path__ + "static/media/certified.f7eaa811.svg";